
import Redireccionar from "../utilities/Redirect/Redirect404"
import { base_url } from "../constants";
import Home from "../pages/Home/main";
import Main from "../pages/Colecciones/principal/main";
import Detalle from "../pages/Colecciones/detalle/main";
import Autores from "../pages/Autores/principal/main";
import Autores_Detalle from "../pages/Autores/detalle/main";
import Autores_Detalle_interior from "../pages/Autores/detalle/detalle_interior";
import Obras from "../pages/Obras/main";
import Novedades from "../pages/Novedades/main";
import Acerca from "../pages/Acerca/main";
import PdfViewer from "../pages/PDFViewer/PdfViewer";
import Busqueda from "../pages/Busqueda/main";
import Busqueda_avanzada from "../pages/Busqueda_avanzada/main";
import Test from "../pages/test/main";

const rutas = [     
    { path: `/${base_url}/test`, component: Test  },
    { path: `/${base_url}/busqueda_avanzada`, component: Busqueda_avanzada  },
    { path: `/${base_url}/busqueda`, component: Busqueda  },
    { path: `/${base_url}/pdf/:id`, component: PdfViewer  },
    { path: `/${base_url}/acerca-de/`, component: Acerca , exact: true },
    { path: `/${base_url}/novedades/`, component: Novedades , exact: true },
    { path: `/${base_url}/obras/:id`, component: Obras },
    { path: `/${base_url}/autores/detalle/:id`, component: Autores_Detalle_interior },
    { path: `/${base_url}/autores/:id`, component: Autores_Detalle },
    { path: `/${base_url}/autores/`, component: Autores , exact: true },
    { path: `/${base_url}/colecciones/:id`, component: Detalle },
    { path: `/${base_url}/colecciones/`, component: Main , exact: true },
    { path: `/${base_url}/`, component: Home, exact: true },
    { path: '*', component: Redireccionar },
]; 

export default rutas;